/**
 * Updates the meta theme color tags for light and dark color schemes
 * @param {Object} params - The parameters object
 * @param {string} params.light - The light theme color (with or without # prefix)
 * @param {string} params.dark - The dark theme color (with or without # prefix)
 * @returns {boolean} - True if successful, false otherwise
 */
export function UpdateMetaThemeColour({ light, dark }) {
    try {
        // Validate inputs
        if (!light || !dark) {
            console.error('UpdateMetaThemeColour: Both light and dark colors must be provided');
            return false;
        }
        
        // Validate color format (basic hex validation)
        const isValidHex = (color) => /^#?([0-9A-F]{3}){1,2}$/i.test(color);
        if (!isValidHex(light) || !isValidHex(dark)) {
            console.error('UpdateMetaThemeColour: Invalid color format provided');
            return false;
        }
        
        // Remove # if present
        const lightColor = light.replace('#', '');
        const darkColor = dark.replace('#', '');
        
        // Get head element once
        const head = document.querySelector('head');
        if (!head) {
            console.error('UpdateMetaThemeColour: Could not find head element');
            return false;
        }
        
        // Remove existing meta theme-color tags
        const existingMetas = document.querySelectorAll('meta[name="theme-color"]');
        existingMetas.forEach(meta => meta.remove());
        
        // Create and append light theme meta tag
        const lightMeta = document.createElement('meta');
        lightMeta.name = 'theme-color';
        lightMeta.content = `#${lightColor}`;
        lightMeta.media = '(prefers-color-scheme: light)';
        head.appendChild(lightMeta);
        
        // Create and append dark theme meta tag
        const darkMeta = document.createElement('meta');
        darkMeta.name = 'theme-color';
        darkMeta.content = `#${darkColor}`;
        darkMeta.media = '(prefers-color-scheme: dark)';
        head.appendChild(darkMeta);
        
        return true;
    } catch (error) {
        console.error('UpdateMetaThemeColour: An error occurred', error);
        return false;
    }
}